export interface IBatchTrackingNumber {
    id: number;
    batchId: number;
    studentId: number;
    firstName?: string;
    lastName?: string;
    trackingNumber?: string;
    activityCode?: string;
    workOrderId: number;
    sendDate?: Date;
    status?: string;
}

const newBatchTrackingNumber = (): IBatchTrackingNumber => ({
    id: 0,
    batchId: 0,
    studentId: 0,
    workOrderId: 0,
})

export const createBatchTrackingNumber = <T extends Partial<IBatchTrackingNumber>>(initialValues: T): IBatchTrackingNumber & T => {
    return Object.assign(newBatchTrackingNumber(), initialValues);
};